/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Car\Pricing\QuantitySelector.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday August 27th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday August 27th 2024 2:23:42 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Typography } from '@mui/material';
import translator from 'MultiLanguage/TranslationWrapper';
import { useState } from 'react';
import { SingleValue } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { getThemeColor, hexToRgba } from 'Utils/ThemeColor';

interface Option {
  readonly label: string;
  readonly value: string;
}

const createOption = (label: string) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ''),
});

const defaultOptions = [
  createOption('1'),
  createOption('2'),
  createOption('3')
];

export default function QuantitySelector(props: {setter: React.Dispatch<React.SetStateAction<number>>, themeColor: string}) {
  const themeColor = getThemeColor(props.themeColor);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [value, setValue] = useState<Option | null>(createOption('1'));

  const handleCreate = (inputValue: string) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setValue(newOption);
      let tmp = parseInt(inputValue);
      if (isNaN(tmp) || tmp <1)
        tmp = 1;
      props.setter(tmp);
    }, 1000);
  };

  const handleChange = (inputValue: SingleValue<Option>) => {
    if (inputValue) {
      let tmp = parseInt(inputValue?.label);
      if (isNaN(tmp) || tmp <1)
        tmp = 1;
      setValue(inputValue);
      props.setter(tmp);
    } else {
      setValue({label: "1", value: "1"});
      props.setter(1);
    }
  };

  return (
    <div>
      <Typography variant="h6" style={{ marginLeft: '20px' }}>
        {translator.decode("pricing.selectCarAmount")}
      </Typography>
      <CreatableSelect
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: hexToRgba(themeColor, 0.4),
            primary50: hexToRgba(themeColor, 0.4),
            primary: themeColor,
          },
        })}
        isClearable
        isDisabled={isLoading}
        isLoading={isLoading}
        onChange={(newValue) => handleChange(newValue)}
        onCreateOption={handleCreate}
        options={options}
        value={value}
      />
    </div>
  );
};
